import { configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import { persistStore } from 'redux-persist';
import persistConfig from './persistConfig';
import baseReducer from './reducers/base';
import userReducer from './reducers/user';
import dropdownReducer from './reducers/dropdown';
import assessmentReducer from './reducers/assessment';
import dataCollectionReducer from './reducers/data-collection';
import zoomLinksReducer from './reducers/zoom-links';

const persistedUserReducer = persistReducer(persistConfig, userReducer);
const persistedDropdownReducer = persistReducer(persistConfig, dropdownReducer);

export const store = configureStore({
    reducer: {
        base: baseReducer,
        user: persistedUserReducer,
        zoomLinks: zoomLinksReducer,
        assessment: assessmentReducer,
        dropdown: persistedDropdownReducer,
        dataCollection: dataCollectionReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;